const VOTENOW_RESULTS = 'votenow-results';

export const getAllResults = () => {
  const resultsJson = localStorage.getItem(VOTENOW_RESULTS);
  try {
    return JSON.parse(resultsJson);
  } catch (e) {
    localStorage.removeItem(VOTENOW_RESULTS);
    return null;
  }
};

export const getResults = hash => {
  const allResults = getAllResults();
  return allResults ? allResults[hash] : null;
};

export const clearResults = hash => {
  mergeResults(hash, null);
};

export const mergeResults = (hash, answers) => {
  const allResults = getAllResults() || {};
  localStorage.setItem(VOTENOW_RESULTS, JSON.stringify({ ...allResults, [hash]: answers }));
};
